import React, { useState, useEffect, useCallback } from 'react'
import { userAchievementListPromise } from 'api/Achievement'
import PerfectScrollbar from 'react-perfect-scrollbar'
import PropTypes from 'prop-types'
import { formatDateTime } from 'common/usual'
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
} from '@material-ui/core'

function AchievementTable (props) {
  const { userId } = props
  const [userAchievement, setUserAchievement] = useState({})
  const [page, setPage] = useState(1)

  const fetchUserAchievement = useCallback(async () => {
    setUserAchievement(await userAchievementListPromise(page, 10, userId))
  }, [page, userId])

  const handlePageChange = (event, page) => {
    setPage(page+1)
  }

  useEffect(() => {
    fetchUserAchievement()
  }, [fetchUserAchievement])

  return (
    <Card>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Badge</TableCell>
                  <TableCell>Created At</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  (userAchievement.rows || []).map(row => (
                    <TableRow key={row.id}>
                      <TableCell>{row.id}</TableCell>
                      <TableCell>{row.achievement && row.achievement.title}</TableCell>
                      <TableCell>{row.badge}</TableCell>
                      <TableCell>{formatDateTime(row.created_at)}</TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={'actions'}>
        <TablePagination
          component="div"
          count={userAchievement.count || 0}
          onChangePage={handlePageChange}
          page={page-1}
          rowsPerPage={10}
          rowsPerPageOptions={[10]}
        />
      </CardActions>
    </Card>
  )
}

AchievementTable.propTypes = {
  userId: PropTypes.any.isRequired
}

export default AchievementTable